export const randomFunnyNoAnswerResponses = [
  // "How should I know, I'm just here for the hay",
  "It's a moo-stery to me",
  "That's udderly baffling",
  // 'How should I know, I just stock the hay bales',
  // "Beats me, I'm on a need-to-gnaw basis",
  // "No clue, that's between you and the herd",
  // "I don't know, my waffle fry is still buffering",
  // 'Not sure, I only flip lids not mysteries',
  // 'I have no idea, the cows redacted that info',
  // "Couldn't tell you, I'm fresh out of clairvoyance",
  // "No idea, that's above my graze grade",
  // "I don't know, I'm a sauce associate not an oracle",
  // "Haven't a clue, try asking R&D: Research & Dairyvancement",
  // "Nope, my brain's still marinatin'",
  // "I'm not sure, I only handle pickles not riddles",
  // "Don't know, the answer's still thawing",
  // "I can't say, I'm just the lemonade intern",
  // "That one's a mystery, and we're closed on Sundays",
  // "I honestly don't know, I just herd something moo-ving by",
  // "Can't help, I only cover tender matters",
  // 'No clue, our waffle-fry philosophers are off shift',
  // "I don't have that answer, I just take orders not prophecies",
  // 'Beats me, please consult Cowtastrophysics',
  // 'Not sure, my crystal nugget is cloudy',
  // "I don't know, I just wrangle straws not truths",
  // "Sorry, that's classified under secret saucery",
  // "I have no idea, I'm the chicken whisperer on break",
  // "Don't ask me, I'll escalate it to Upper Moo-nagement",
  // 'No clue, the answer went out for a milk run',
  // "I'm stumped, I seat condiments not debates",
  // "I don't know, I'm more cluck than luck today",
  // "Couldn't tell you, the cows ate my homework again",
  // "I'm not sure, I'm a biscuit technician not IT",
  // "No idea, that's a free-range question",
  // "I don't know, my knowledge base is fried not grilled",
  // 'Not sure, I just do waffle grids not data grids',
  // "I have no clue, I'm running on low poul-try power",
  // "I don't know, please hold while I consult the udderverse",
  // 'No idea, I make it saucy not certain',
  // "Couldn't say, I serve nuggets not knowledge",
  // "I don't know, that's a mystery meal with no sides",
  // 'Beats me, I manage napkins not enigmas',
  // 'No idea, let me ping Chick-intel-A',
];

/** Picks a fallback line deterministically so the same search keeps the same copy. */
export const getStableFunnyNoAnswerResponse = (seed: string): string => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % randomFunnyNoAnswerResponses.length;
  return randomFunnyNoAnswerResponses[index] ?? "It's a moo-stery to me";
};
